import React from 'react'
import { Helmet } from 'react-helmet'
import { FormProvider } from 'react-hook-form'

import gremlinLogo from 'assets/gremlin-logo-primary.svg'
import Image from 'components/common/Image'
import Text, { styles } from 'components/common/Text'
import theme from 'theme'
import { SignedOutFormProps } from 'types/authentication/registration/self-service/account-setup'

export const SignedOutForm: React.FC<SignedOutFormProps> = ({
  title,
  onSubmit,
  methods,
  children
}) => {
  return (
    <>
      <Helmet title={title} />
      <FormProvider {...methods}>
        <form
          css={{
            border: theme.border.base,
            textAlign: 'center',
            backgroundColor: 'white',
            borderRadius: theme.borderRadius[1],
            paddingLeft: theme.space[7],
            paddingRight: theme.space[7],
            paddingTop: theme.space[5],
            paddingBottom: theme.space[5]
          }}
          onSubmit={onSubmit}
        >
          <Image alt="Gremlin" height={theme.space[5]} src={gremlinLogo} />
          <Text
            as="h1"
            css={{
              ...styles.h2,
              fontWeight: theme.fontWeights[0],
              marginTop: theme.space[2],
              marginBottom: theme.space[4]
            }}
          >
            {title}
          </Text>

          {children}
        </form>
      </FormProvider>
    </>
  )
}
